module.exports = __webpack_public_path__ + "media/images/japan/kaga_guide/lacquerware-c06e8892e2e0f00f51853d30dc88af67.jpg";